import { Checkbox, Input, Select } from "antd";
import styled, { css } from "styled-components";

import { Palette } from "../../core/styles/theme";

//------------------------------------------------------------------------------------------------
// --------Define CSS rules------------------------------------------------------------------------
//------------------------------------------------------------------------------------------------
const inputStyles = css`
    &.aevi-input {
        font-family: "RobotoLight" !important;
        font-size: 12pt;
        font-weight: 300;
        line-height: 18pt;
        color: #3e383a; // Create colors in Pallette?
        border: 1pt solid ${Palette.MidGray};
        border-radius: 4pt;
        padding: 6pt 10pt;
        min-width: 15ch;
        height: 40px;
        width: 100%;

        &:hover {
            border-color: ${Palette.DarkGreen};
        }
    }

    &.aevi-input-disabled {
        color: ${Palette.DisabledColor} !important;
    }

    &.aevi-input-text {
    }

    &.aevi-input-number {
    }

    &.aevi-input-textarea {
        min-height: 80px;
    }

    &.aevi-input-checkbox {
        font-size: 12pt;
        margin: 0 !important;
    }

    &.aevi-input-checkbox-marked {
    }

    &.aevi-checkbox-disabled {
        color: ${Palette.DisabledColor} !important;
        background: ${Palette.DisabledBackground};
        height: 18pt;
        width: 18pt;
    }

    &.aevi-input-select {
        min-width: 15ch;
        min-height: 40px;
    }

    &.aevi-select-disabled {
        color: ${Palette.DisabledColor} !important;
        background: ${Palette.DisabledBackground};
        cursor: not-allowed;
    }
`;

//------------------------------------------------------------------------------------------------
// --------Define styles---------------------------------------------------------------------------
//------------------------------------------------------------------------------------------------
const InputHtmlStyle = styled.input`
    ${inputStyles};
`;

const InputAntStyle = styled(Input)`
    ${inputStyles};
`;

const InputNumberAntStyle = styled(Input)`
    ${inputStyles};
`;

const InputPasswordAntStyle = styled(Input.Password)`
    ${inputStyles};
`;

const TextareaInputAntStyle = styled(Input.TextArea)`
    ${inputStyles};
`;
//------------------------------------------------------------------------------------------------
// --------Export components-----------------------------------------------------------------------
//------------------------------------------------------------------------------------------------
export const InputTextHtmlStyle = styled(InputHtmlStyle).attrs(() => ({ className: "aevi-input aevi-input-text" as string }))``;
export const InputTextStyle = styled(InputAntStyle).attrs(() => ({ className: "aevi-input aevi-input-text" as string }))``;
export const InputNumberStyle = styled(InputNumberAntStyle).attrs(() => ({ className: "aevi-input aevi-input-number" as string }))``;
export const InputPasswordStyle = styled(InputPasswordAntStyle).attrs(() => ({ className: "aevi-input aevi-input-text" as string }))``;
export const TextareaInputStyle = styled(TextareaInputAntStyle).attrs(() => ({ className: "aevi-input aevi-input-textarea" as string }))``;

//------------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------------
//------------------------------------------------------------------------------------------------

const SelectInputHtmlStyles = styled.select`
    ${inputStyles};
`;

const SelectInputAntStyles = styled(Select)`
    ${inputStyles};
    // stretching the height when a multiselect has many options and goes to multiple lines
    ${(props) => {
        if (props.mode === "multiple") {
            return css`
                height: auto !important;
                &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
                    margin: -3px 0 !important;
                }
            `;
        }
        return css`
            height: 40px;
        `;
    }}}

    &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
        border: 0;
        padding: 0;
    }

    &.ant-select-focused.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer)
        .ant-select-selector {
        box-shadow: none;
    }

    &.ant-select-single .ant-select-selection-item {
        font-size: 12pt;
    }

    &.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
        background: transparent;
        cursor: not-allowed;
    }

    &.ant-select .ant-select-arrow {
        margin-top: -5px;
        font-size: 14px;
        color: ${Palette.AeviBlack};
    }
`;

export const SelectInputHtmlStyle = styled(SelectInputHtmlStyles).attrs(() => ({ className: "aevi-input aevi-input-select" as string }))``;
export const SelectInputStyle = styled(SelectInputAntStyles).attrs(() => ({ className: "aevi-input aevi-input-select" as string }))``;
export const SelectInputMultiStyle = styled(SelectInputStyle).attrs(() => ({
    className: "aevi-input aevi-input-select" as string,
    mode: "multiple" as "multiple" | "tags",
}))``;

const CheckboxInputAntStyles = styled(Checkbox)`
    ${inputStyles};

    & .ant-checkbox .ant-checkbox-inner {
        height: 18pt;
        width: 18pt;
        border-color: ${Palette.HeroGreen} !important;
    }

    & .ant-checkbox-checked .ant-checkbox-inner {
        background-color: ${Palette.HeroGreen} !important;
        border-color: ${Palette.HeroGreen} !important;
        height: 18pt;
        width: 18pt;
    }

    & .ant-checkbox-checked .ant-checkbox-inner:after {
        transform: rotate(40deg) scale(1.5) translate(-0%, -50%) !important;
    }

    & .ant-checkbox-disabled .ant-checkbox-inner {
        border-color: ${Palette.DisabledBackground} !important;
        background-color: ${Palette.DisabledBackground} !important;
    }
`;
export const CheckboxInputStyle = styled(CheckboxInputAntStyles).attrs(() => ({ className: "aevi-input-checkbox" as string }))``;
